import React, { useContext } from "react";
import { Theme, ThemeContext } from "../ThemeProvider/ThemeProvider";
import HighlightedIcon, { HighlightedIconType } from "../HighlightedIcon";
import IconWrapper from "../Icons/IconWrapper";
import { IconSizes } from "../Icons/PropTypes/IconSizes";
import { NotificationTypes } from "./types";
const NotificationContent = ({ description, message, type }) => {
    const theme = useContext(ThemeContext);
    const highlightIcon = theme === Theme.Akinox;
    const getIcon = () => {
        let iconName = null;
        let iconType = HighlightedIconType.Default;
        switch (type) {
            case NotificationTypes.Success:
                iconName = "CheckCircle";
                iconType = HighlightedIconType.Success;
                break;
            case NotificationTypes.Warn:
            case NotificationTypes.Warning:
                iconName = "AlertTriangle";
                iconType = HighlightedIconType.Warning;
                break;
            case NotificationTypes.Error:
                iconName = "AlertCircle";
                iconType = HighlightedIconType.Danger;
                break;
            default:
        }
        if (!iconName)
            return null;
        const icon = React.createElement(IconWrapper, { size: IconSizes.Small, name: iconName });
        if (!highlightIcon)
            return icon;
        return (React.createElement(HighlightedIcon, { size: IconSizes.Small, type: iconType }, icon));
    };
    const icon = getIcon();
    return (React.createElement("div", { className: "gerudo-notification-content" },
        icon && React.createElement("div", { className: "gerudo-notification-icon" }, icon),
        React.createElement("div", { className: "gerudo-notification-text" },
            message && React.createElement("div", { className: "gerudo-notification-title" }, message),
            description && React.createElement("div", { className: "gerudo-notification-description" }, description))));
};
export default NotificationContent;
//# sourceMappingURL=NotificationContent.js.map